import { h } from '@stencil/core';
import { ChipsBlock } from './chips-block';
import { SearchBlock } from './search-block';
export class CommerceConnectorView {
  constructor() {
    this.onDialogContentScroll = () => {
      this.contentScrolled = this.dialogContent.scrollTop > 0;
    };
    this.renderContent = (distributors, favorites, labels) => {
      const { noSearchResults, allRetailers, favoriteRetailers, priceUnavailable } = labels;
      const isFavorites = favorites && !!favorites.length;
      if (!distributors.length) {
        return h("pes-cc-no-result", { label: noSearchResults });
      }
      return (h("div", null, isFavorites && h("div", { class: "cc-content__result-title" }, favoriteRetailers), isFavorites && (h("pes-cc-items", { isFavoriteBlock: true, distributors: favorites, priceUnavailableLabel: priceUnavailable })), isFavorites && h("div", { class: "cc-content__result-title" }, allRetailers), h("pes-cc-items", { distributors: distributors, priceUnavailableLabel: priceUnavailable })));
    };
    this.isOpen = undefined;
    this.header = undefined;
    this.product = undefined;
    this.notification = undefined;
    this.isContentVisible = undefined;
    this.labels = undefined;
    this.distributors = undefined;
    this.favorites = undefined;
    this.showLoader = undefined;
    this.showSearch = undefined;
    this.searchHeading = undefined;
    this.searchPlaceholder = undefined;
    this.searchMaxLength = undefined;
    this.searchButtonLabel = undefined;
    this.searchMessage = undefined;
    this.searchShowValidateMessage = undefined;
    this.searchValue = undefined;
    this.shouldChipsBeVisible = false;
    this.ccStandardProductTabLabel = undefined;
    this.ccCircularProductTabLabel = undefined;
    this.ccActiveProductTabLabel = undefined;
    this.hasLinearRetailers = undefined;
    this.hasCircularRetailers = undefined;
    this.contentScrolled = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    this.dialogContent.addEventListener('scroll', this.onDialogContentScroll);
  }
  render() {
    const chipsData = [];
    this.hasLinearRetailers !== false && chipsData.push(this.ccStandardProductTabLabel);
    this.hasCircularRetailers !== false && chipsData.push(this.ccCircularProductTabLabel);
    return (h("div", { class: "cc-wrapper" }, h("se-dialog", { size: "xlarge", color: "primary", open: this.isOpen, "page-scroll": "false" }, h("se-dialog-header", { "close-icon": "true", option: "indent" }, this.header), h("div", { class: "cc-body" }, h("se-dialog-content", { option: "fill", ref: (el) => (this.dialogContent = el) }, this.product && (h("div", { class: {
        'cc-header': true,
        'cc-header--content-scrollable': this.isContentVisible,
        'cc-header--content-scrolled': this.contentScrolled,
      } }, h("div", { class: "cc-header__info-wrapper" }, h("div", { class: "cc-header__img", dir: document.documentElement.dir }, h("img", { src: this.product.imgUrl, alt: this.product.imgAlt })), h("div", { class: "cc-header__info" }, h("div", { class: "cc-header__info-title" }, this.product.commercialReference), h("div", { class: "cc-header__info-description" }, this.product.description), this.shouldChipsBeVisible && (h(ChipsBlock, { data: chipsData, title: this.labels.chipsLabel, selected: this.ccActiveProductTabLabel })))), h("div", null, h("div", { class: "cc-header__result-title" }, this.labels.availableDistributors), this.showSearch
      && h(SearchBlock, { notification: this.notification, searchPlaceholder: this.searchPlaceholder, searchMaxLength: this.searchMaxLength, searchButtonLabel: this.searchButtonLabel, searchShowValidateMessage: this.searchShowValidateMessage, searchMessage: this.searchMessage, searchValue: this.searchValue })))), (!this.showLoader && this.isContentVisible) && (h("div", { class: "cc-content" }, h("div", { class: {
        'cc-content__result-wrapper': true,
        'cc-content__result-wrapper--no-result': !this.distributors.length,
      } }, this.renderContent(this.distributors, this.favorites, this.labels))))), this.showLoader && (h("div", { class: "cc-content__loading-wrapper" }, h("se-block", null, h("se-loading", { loading: true }))))))));
  }
  static get is() { return "pes-cc-main-view"; }
  static get originalStyleUrls() {
    return {
      "$": ["main.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["main.css"]
    };
  }
  static get properties() {
    return {
      "isOpen": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Option to set visibility of the modal."
        },
        "attribute": "is-open",
        "reflect": false
      },
      "header": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Text that goes to the header."
        },
        "attribute": "header",
        "reflect": false
      },
      "product": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductInfo",
          "resolved": "{ circularType?: CircularProductTypes; circularNatureLabel?: string; circularProductRelationships?: CircularProductRelationships; commercialReference?: string; description?: string; imgUrl?: string; imgAlt?: string; }",
          "references": {
            "ProductInfo": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Set of options that describe product to render in the modal."
        }
      },
      "notification": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Text for info message of the search block."
        },
        "attribute": "notification",
        "reflect": false
      },
      "isContentVisible": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Option that set visibility of the content."
        },
        "attribute": "is-content-visible",
        "reflect": false
      },
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{\n    allRetailers: string;\n    favoriteRetailers: string;\n    priceUnavailable: string;\n    noSearchResults: string;\n    availableDistributors?: string;\n    chipsLabel?: string;\n  }",
          "resolved": "{ allRetailers: string; favoriteRetailers: string; priceUnavailable: string; noSearchResults: string; availableDistributors?: string; chipsLabel?: string; }",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Set of text labels used in the modal."
        }
      },
      "distributors": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Distributor[]",
          "resolved": "Distributor[]",
          "references": {
            "Distributor": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "List of distributors to render as cards in the modal."
        }
      },
      "favorites": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Distributor[]",
          "resolved": "Distributor[]",
          "references": {
            "Distributor": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "List of favorites distributors to render as cards in the modal."
        }
      },
      "showLoader": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Option that set visibility of the loader."
        },
        "attribute": "show-loader",
        "reflect": false
      },
      "showSearch": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show search input."
        },
        "attribute": "show-search",
        "reflect": false
      },
      "searchHeading": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The text that is displayed above the search input."
        },
        "attribute": "search-heading",
        "reflect": false
      },
      "searchPlaceholder": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The placeholder text that is displayed inside the search input."
        },
        "attribute": "search-placeholder",
        "reflect": false
      },
      "searchMaxLength": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Max length of the zip-code."
        },
        "attribute": "search-max-length",
        "reflect": false
      },
      "searchButtonLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The text that is displayed inside the search input button."
        },
        "attribute": "search-button-label",
        "reflect": false
      },
      "searchMessage": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The message that is displayed if no retailer found."
        },
        "attribute": "search-message",
        "reflect": false
      },
      "searchShowValidateMessage": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show validation message."
        },
        "attribute": "search-show-validate-message",
        "reflect": false
      },
      "searchValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Default value of the search input."
        },
        "attribute": "search-value",
        "reflect": false
      },
      "shouldChipsBeVisible": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "should-chips-be-visible",
        "reflect": false,
        "defaultValue": "false"
      },
      "ccStandardProductTabLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "cc-standard-product-tab-label",
        "reflect": false
      },
      "ccCircularProductTabLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "cc-circular-product-tab-label",
        "reflect": false
      },
      "ccActiveProductTabLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "cc-active-product-tab-label",
        "reflect": false
      },
      "hasLinearRetailers": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "has-linear-retailers",
        "reflect": false
      },
      "hasCircularRetailers": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "has-circular-retailers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "contentScrolled": {}
    };
  }
  static get elementRef() { return "el"; }
}
